import { request } from "utils/request";
import { AxiosPromise } from "axios";

export const customerAnalyticsApi = {
  findAll: (params?: any): AxiosPromise<any> =>
    request({
      url: "/v1/admin/customer-analytics",
      params,
    }),
};
